<template>
  <div style="width: 100%;height: 100%;box-sizing: border-box" :style="{
    textAlign: option.attribute.textAlign, fontSize: option.attribute.textSize + 'px',
    color: textColor, backgroundColor: bgColor, backgroundImage: gradualColor,
    '-webkit-background-clip': bgClip,
    fontStyle: option.attribute.fontStyle, fontWeight: option.attribute.fontWeight, lineHeight: option.attribute.textLineHeight + 'px',
    letterSpacing: option.attribute.letterSpacing + 'px', borderRadius: option.attribute.borderRadius + '%',
    fontFamily: option.attribute.textFamily, textDecoration: option.attribute.textDecoration,
    ...setStyle,

  }" :class="[option.attribute.isEllipsis ? 'my_text' : '',option.attribute.isScale ? 'text-isScale' : '']" @mouseover="mouseoverHandler" @click="clickHandler">
    {{ cptData?.value }}

  </div>
</template>

<script>
import { getDataJson, pollingRefresh, getDefaultValue, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import cptTextOption from "@/components/element/attrs/cpt-text-option";
import { compareByOperator } from "@/utils/threshold-compare";
import { getResByDatasetIdApi } from "@/api/dataset/dataset";
import { LoginArrId, } from "@/utils/func";
// import { mixinsCom } from "@/mixins/globalAllComps";

export default {
  name: "cpt-text",
  props: { option: Object, current: Object, components: Array, cacheComponents: Array, refMap: Object, show: Boolean },

  computed: {
    bgColor() {
      if (this.alarmed) {
        return this.option.attribute.alarmConfig.bgColor
      } else {
        return this.option.attribute.enableGradual === 1 ? this.option.attribute.bgColor : 'transparent'
      }
    },
    textColor() {
      // console.log(this.cptData.value, 'cptData?.value');
      let cptDataValue = String(this.cptData.value)
      let isValue = cptDataValue && cptDataValue?.includes('-') == false

      // console.log(this.cptData.value, 'aidjasi0djiasjiadiajsdajidajis');

      if (this.option.attribute.sqlSetValue == '1' && isValue) {
        return this.option.attribute.sqlSetValueColor
      }
      if (this.alarmed) {
        return this.option.attribute.alarmConfig.textColor
      } else {
        return this.option.attribute.enableGradual === 1 ? this.option.attribute.textColor : 'transparent'
      }
    },
    gradualColor() {
      if (this.option.attribute.enableGradual === 1 || this.alarmed) {
        return ''
      } else if (this.option.attribute.enableGradual === 2) {//从左到右
        return 'linear-gradient(to right, ' + this.option.attribute.gradualColor.toString() + ')'
      }
      return 'linear-gradient(to bottom, ' + this.option.attribute.gradualColor.toString() + ')'//从上到下
    },
    bgClip() {
      if (this.alarmed) {
        return null
      }
      return this.option.attribute.enableGradual === 1 ? null : 'text'
    },
    setStyle() {
      let isValue = this.cptData?.value?.length
      if (isValue) {
        return {
          borderStyle: this.option.attribute.borderStyle, borderWidth: this.option.attribute.borderWidth + 'px', borderColor: this.option.attribute.borderColor,
          "--lineClamp": this.option.attribute.lineClamp,
        }
      } else {
        return {
          borderStyle: this.option.attribute.borderStyle, borderWidth: this.option.attribute.borderWidth + 'px', borderColor: this.option.attribute.borderColor,
        }
      }
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    }

  },

  data() {
    return {
      cptData: {},
      uuid: null,
      alarmed: false,
      // jingData:'',
      newData: "",
      jsFunFlag: false,
      requestJson: {}
    }
  },

  watch: {
    "current.cptShow"(val) {
      // console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        // console.log('开始');
        this.refreshCptData();
      }
    }

  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    //mark:合并属性，由于属性字段更新，导致旧版本数据不能正常渲染组件或配置表单，所有组件都应执行这项操作！！！
    const temp = JSON.parse(JSON.stringify(cptTextOption.attribute))
    this.option.attribute = Object.assign({}, temp, this.option.attribute);

    if (this.option.cptDataForm.dataSource == '1') {
      this.option.cptDataForm.resData = JSON.parse(this.option.cptDataForm.dataText)
    }

    if (this.dataReload.includes(0)) {
      this.option.cptDataForm['isCache'] = false

      this.refreshCptData();

    }
  },

  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () => {
        const defaultValue = getDefaultValue(this.option.attribute)
        if (defaultValue) {
          this.cptData = { value: defaultValue };
        } else {
          this.loadData(cptDataForm, paras)
        }
      }, this.components)
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        // console.log("======textres====", res);
        that.newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        // console.log(that.newData,'qwdijwqijijqdi')

        // that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        // if(cptDataForm.dataSource == '1'){
        //   if(this.current.id == 'b114f1c0-3e8f-11ef-aed2-e369b48a2647'){
        //   console.log('12t4ff43443')
        // }
        //   that.jingData = JSON.parse(JSON.stringify(res))
        // 九宫格处理渲染文本处理 - 当文本是九宫格子控件本控件不执行自调用
        if(!that.option.interaction.fatherGridId) {
          that.processData(cptDataForm, that.newData, that.jsFunFlag)  //监听里面会执行的
        }
        // }
        // console.log("======that.newData====", that.newData);
      }, this.current)
    },

    processData(cptDataForm, res, jsFunFlag, isFromGrid) {
      // console.log(this.current.id, 'yuiirtrrty')
      if(typeof res[0] === 'object') {
        if('NAME' in res[0]) {
          debugger
        }

      }
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == '4') {
        // console.log(res,'??')
        this.requestJson = (res[0] || {})
        // console.log('wenben1',this.current.id, this.cptData)
        // if (this.current.cptOption.attribute.cptFatherId 
        // && isFromGrid != 'ninegrid' 
        // && this.refMap[this.current.cptOption.attribute.cptFatherId]?.current.cptType != 'combination'
        // && !this.refMap[this.current.cptOption.attribute.cptFatherId]?.current.cptOption.attribute.isPop) return
        // console.log('wenben2',this.current.id, this.cptData)
        // 第二层判断 ，如果没有配转换脚本
        //判断此控件在九宫格里面就不请求数据

        // console.log(this.current.cptOption.interaction.fatherGridId, 'plplplplplplp')
        const dataKey = this.option.attribute.cptTableData;
          // console.log(res,'resresresresres')
          let isArray = Array.isArray(res)
          // console.log(isArray,'isArray');
          // 创建一个新的数组用于存储结果
          let newres = [];
          let newObj = {}
          if(isArray) {
            newObj = { ...res[0] }
          } else {
            // console.log(res)
            newObj = res
          }
      
          // 如果dataKey中的value有值并且在newObj对象中有对应的值
          // if (dataKey[0].value && newObj[dataKey[0].value]) {
          // 兼容盐城小程序首页写法 datakey[0].value == ""  不赋值的情况
          newObj[dataKey[0].namekey] = String(dataKey[0].value)?.length ? newObj[dataKey[0]?.value] : newObj?.value
          // }
          newres.push(newObj);
          /**
           * @title  多个接口返回没有顺序 会被无值数据覆盖有值数据
           * 临时解决办法： 当值为undefined不赋值
           */
          if (newres[0].value !== 'undefined') {
            this.cptData = newres[0];
          }
      } else { //不是数据集类型，是静态数据
        // console.log('uyttr', this.newData)
        this.cptData = this.newData
      }
      const attr = this.option.attribute
      if (attr.alarmConfig && attr.alarmConfig.threshold) {//告警判断
        that.alarmed = compareByOperator(attr.alarmConfig.operator, that.cptData.value, attr.alarmConfig.threshold)
      }


      // console.log(this.cptData, 'qwidjjqidiqwijdqijdiqjwijqwdjqwdijqwidjqwdiji');

    },
    getValue() {
      return this.cptData?.value
    },
    setValue(value) {
      // console.log('text setValue', value)
      this.cptData.value = value
      // console.log(this.newData)
    },
    clickHandler(event) {

      if (LoginArrId.includes(this.current.id)) {//需要登录,需要用户地址
        // console.log('检查用户是否登录')
        let isLogin = FuncEvents.getUserId()
        if (!isLogin) {
          return
        }
        // MessagePlugin.warning('暂无地址，请新增默认地址');
        getResByDatasetIdApi('aa1f903fe35b194dbdfe725256ef27bb', 'sql', { userId: isLogin }).then(res => {
          if (res.code == 200) {

            const result = JSON.parse(res.data.apiRes)
            if (result.length > 0) {
              // console.log('有默认收货地址')
              this.$emit("clickHandler", this.option.interaction, {
                default: 'default',
                event: event,
                current: this.current,
              }, this.cptData.value, 'cpt-text', '', this.current)
            } else {
              // console.log('没有默认收货地址')
              Login.goToWXPage({ url: '/pages/xd-yytPage/childrenDpPage/dp_index_6?url=https://www.xdwater365.com:6883/v/c07f44cf3bc5e403347dc47a1c6d0d67' })
            }
          }

        })
      } else {
        this.$emit("clickHandler", this.option.interaction, {
          default: 'default',
          event: event,
          current: this.current,
        }, this.cptData.value, 'cpt-text', '', this.current)
      }
    },
  },
}
</script>

<style scoped>
.my_text {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: var(--lineClamp);
  -webkit-box-orient: vertical;
}

.text-isScale:hover {
  transform: scale(1.1);
  transition: .3s ease-in-out;
  cursor: pointer;
}
</style>
